import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MenuNavigation, NAVIGATION_STRUCTURE } from '../navigation';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  navigationStructure: MenuNavigation[] = NAVIGATION_STRUCTURE;
  hide = false;

  constructor(private router: Router) {
    this.updateActiveNavigation(this.router.url);

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateActiveNavigation(event.urlAfterRedirects);
    });
  }

  private updateActiveNavigation(url: string) {
    const currentRoute = url
      .split('?')[0]
      .split('#')[0]
      .replace(/^\/+|\/+$/g, '');
    let activeIndex = -1;
    let activeRouteLength = -1;

    this.navigationStructure.forEach((node, index) => {
      node.active = false;

      const routes = [node.route, ...(node.activeRoutes || [])]
        .filter((route): route is string => typeof route === 'string');
      const matchingRoute = routes
        .filter(route => this.routeMatches(currentRoute, route))
        .sort((a, b) => b.length - a.length)[0];

      if (matchingRoute && matchingRoute.length > activeRouteLength) {
        activeIndex = index;
        activeRouteLength = matchingRoute.length;
      }
    });

    if (activeIndex === -1 && currentRoute === '') {
      activeIndex = this.navigationStructure.findIndex(node => node.route === 'dashboard');
    }

    if (activeIndex === -1) {
      return;
    }

    const activeNode = this.navigationStructure[activeIndex];
    activeNode.active = true;

    if (activeNode.level > 0) {
      this.navigationStructure
        .filter(node => node.expandable && node.level === 0)
        .forEach(node => node.isExpanded = false);

      let parentLevel = activeNode.level - 1;
      for (let index = activeIndex - 1; index >= 0 && parentLevel >= 0; index--) {
        const parent = this.navigationStructure[index];
        if (parent.level !== parentLevel) {
          continue;
        }

        parent.active = true;
        parent.isExpanded = true;
        parentLevel--;
      }
    }
  }

  private routeMatches(currentRoute: string, navigationRoute: string): boolean {
    return currentRoute === navigationRoute || currentRoute.startsWith(`${navigationRoute}/`);
  }
}
